export default "__VITE_ASSET__DdG9IaFJ__"